import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "space-y-4"
};
const _hoisted_2 = { class: "flex gap-4" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "flex-1" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = {
    key: 0,
    class: "mb-6"
};
const _hoisted_8 = { class: "flex items-start gap-3" };
const _hoisted_9 = { class: "w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0" };
const _hoisted_10 = ["src", "alt", "onError"];
const _hoisted_11 = { class: "flex-1" };
const _hoisted_12 = { class: "text-sm text-gray-900" };
const _hoisted_13 = {
    key: 1,
    class: "space-y-2"
};
const _hoisted_14 = ["value"];
const _hoisted_15 = { class: "flex-1" };
const _hoisted_16 = { class: "flex items-center gap-3" };
const _hoisted_17 = { class: "w-2 h-2 rounded-full bg-white" };
const _hoisted_18 = { class: "flex-1" };
const _hoisted_19 = { class: "font-medium text-gray-900" };
const _hoisted_20 = { class: "text-right" };
const _hoisted_21 = {
    key: 0,
    class: "text-sm text-gray-500"
};
const _hoisted_22 = {
    key: 1,
    class: "text-sm font-medium text-gray-900"
};
const _hoisted_23 = { key: 2 };
const _hoisted_24 = { class: "text-base font-semibold text-gray-900 mb-2" };
const _hoisted_25 = { class: "space-y-2" };
const _hoisted_26 = ["onClick"];
const _hoisted_27 = { class: "flex-1" };
const _hoisted_28 = { class: "flex items-center gap-3" };
const _hoisted_29 = { class: "w-2 h-2 rounded-full bg-white" };
const _hoisted_30 = { class: "flex-1" };
const _hoisted_31 = { class: "font-medium text-gray-900" };
const _hoisted_32 = {
    key: 0,
    class: "text-right"
};
const _hoisted_33 = { class: "text-sm font-medium text-gray-900" };
const _hoisted_34 = { key: 3 };
const _hoisted_35 = { class: "space-y-3" };
const _hoisted_36 = ["checked", "onChange"];
const _hoisted_37 = { class: "flex-1" };
const _hoisted_38 = { class: "flex items-center gap-3" };
const _hoisted_39 = {
    class: "w-3 h-3 text-white",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "3",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
};
const _hoisted_40 = { class: "flex-1" };
const _hoisted_41 = { class: "font-medium text-gray-900" };
const _hoisted_42 = { class: "text-right" };
const _hoisted_43 = { class: "text-sm font-medium text-gray-900" };
const _hoisted_44 = { key: 4 };
const _hoisted_45 = { class: "space-y-2" };
const _hoisted_46 = ["checked", "onChange"];
const _hoisted_47 = { class: "flex-1" };
const _hoisted_48 = { class: "flex items-center gap-3" };
const _hoisted_49 = {
    class: "w-3 h-3 text-white",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "3",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
};
const _hoisted_50 = { class: "flex-1" };
const _hoisted_51 = { class: "font-medium text-gray-900" };
const _hoisted_52 = {
    key: 0,
    class: "relative"
};
const _hoisted_53 = { class: "absolute text-xs text-gray-400 mt-1 bottom-4 right-3 z-10" };
import { computed, ref, watch, onMounted, nextTick } from "vue";
import { useTheme } from '@shared/composables/useTheme';
import defaultFoodImage from "@/assets/default-food-image.svg";
import { debugProductData, validateModalData } from "@shared/utils/modalDebug";
// Static icon imports for better webpack compatibility
import glutenIcon from "@shared/assets/icons/gluten-icon.svg";
import milkIcon from "@shared/assets/icons/milk-icon.svg";
import eggIcon from "@shared/assets/icons/egg-icon.svg";
import fishIcon from "@shared/assets/icons/fish-icon.svg";
import peanutIcon from "@shared/assets/icons/peanut-icon.svg";
import soyIcon from "@shared/assets/icons/soy-icon.svg";
import nutsIcon from "@shared/assets/icons/nuts-icon.svg";
import celeryIcon from "@shared/assets/icons/celery-icon.svg";
import mustardIcon from "@shared/assets/icons/mustard-icon.svg";
import sesameIcon from "@shared/assets/icons/sesame-icon.svg";
import sulfitesIcon from "@shared/assets/icons/sulfites-icon.svg";
import shellfishIcon from "@shared/assets/icons/shellfish-icon.svg";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfigContent',
    props: {
        product: {},
        selectedExtras: {},
        removedIngredients: {},
        specialInstructions: {},
        quantity: {},
        selectedSize: {},
        ingredientCategories: {}
    },
    emits: ["update:selectedExtras", "update:removedIngredients", "update:specialInstructions", "update:quantity", "update:selectedSize"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // 🎨 Theme System
        const { theme } = useTheme();
        const warningColor = computed(() => theme.value.colors.warning || theme.value.colors.primary);
        const requiredIndicatorColor = computed(() => theme.value.colors.primary);
        const allergenContainerStyle = computed(() => ({
            backgroundColor: theme.value.colors.surface || '#f8fafc',
            borderColor: warningColor.value
        }));
        const allergenDividerStyle = computed(() => ({
            borderColor: warningColor.value
        }));
        const allergenItemStyle = computed(() => ({
            borderColor: warningColor.value
        }));
        // ✅ DEBUG: Monitor product data when component mounts and when product changes
        onMounted(() => {
            if (props.product) {
                debugProductData(props.product, "ProductConfigContent mounted");
                const validation = validateModalData(props.product);
                if (!validation.isValid) {
                    console.warn("❌ Modal data validation failed:", validation.issues);
                }
            }
        });
        // ✅ Mandatory ingredients selection state - MUST be defined BEFORE watch uses it
        // Structure: { groupId: selectedIngredientId }
        const selectedMandatoryIngredients = ref({});
        // Track last product ID to detect actual product changes (not just size changes)
        const lastProductId = ref(null);
        watch(() => props.product, (newProduct) => {
            if (newProduct) {
                debugProductData(newProduct, "ProductConfigContent product changed");
                // ✅ Only reset mandatory ingredients when product ID actually changes (not on size change)
                const currentProductId = newProduct.id || newProduct._id;
                const previousProductId = lastProductId.value; // ✅ Use stored value to detect product changes
                // Reset only if this is a DIFFERENT product
                if (currentProductId !== previousProductId && previousProductId !== null) {
                    console.log('🔄 [ConfigContent] Product ID changed:', previousProductId, '→', currentProductId);
                    selectedMandatoryIngredients.value = {};
                }
                else if (previousProductId === null) {
                    console.log('🆕 [ConfigContent] Initial product load:', currentProductId);
                    // Initial load - don't reset, selections are already empty
                }
                else {
                    console.log('📏 [ConfigContent] Same product (size/extra change), keeping mandatory selections:', {
                        productId: currentProductId,
                        previousProductId,
                        selections: selectedMandatoryIngredients.value
                    });
                }
                lastProductId.value = currentProductId;
                // ✅ DEBUG: Log size data specifically
                if (newProduct.sizes && newProduct.sizes.length > 0) {
                    console.log('🔍 [ConfigContent] Product sizes RECEIVED:', {
                        productName: newProduct.name,
                        hasSizes: newProduct.hasSizes,
                        sizesCount: newProduct.sizes.length,
                        sizes: newProduct.sizes.map((s) => ({
                            name: s.name,
                            id: s.id,
                            price: s.price,
                            priceCent: s.priceCent,
                            priceModifierCent: s.priceModifierCent,
                            isDefault: s.isDefault
                        }))
                    });
                    // 🚨 CRITICAL DEBUG: Check if "Klein" size has wrong price
                    const kleinSize = newProduct.sizes.find((s) => s.name.toLowerCase().includes('klein'));
                    if (kleinSize) {
                        console.error('🔥 [ConfigContent] KLEIN SIZE DEBUG:', {
                            name: kleinSize.name,
                            price: kleinSize.price,
                            priceCent: kleinSize.priceCent,
                            priceModifierCent: kleinSize.priceModifierCent,
                            expectedPrice: 0,
                            actualPrice: kleinSize.price,
                            WRONG: kleinSize.price !== 0,
                            SOURCE: 'ConfigContent received this from props.product'
                        });
                    }
                }
            }
        }, { immediate: true });
        // ✅ Direct prop-driven state (no local mirrors).
        // Eliminates circular sync watchers that caused Vue render races.
        const localSpecialInstructions = ref(props.specialInstructions);
        const localQuantity = ref(props.quantity);
        const localSelectedSize = ref(props.selectedSize || null);
        // Allergen dropdown state
        const allergenDropdownOpen = ref(false);
        // Special instructions dropdown state
        const specialInstructionsOpen = ref(false);
        const specialInstructionsTextarea = ref(null);
        const removedIngredientIds = computed(() => {
            if (!Array.isArray(props.removedIngredients))
                return [];
            return props.removedIngredients.map((item) => typeof item === "string" ? item : item.id);
        });
        watch(localSpecialInstructions, (newValue) => {
            emit("update:specialInstructions", newValue);
        });
        watch(localQuantity, (newValue) => {
            emit("update:quantity", newValue);
        });
        watch(localSelectedSize, (newValue) => {
            emit("update:selectedSize", newValue);
        });
        watch(() => props.specialInstructions, (newValue) => {
            if (localSpecialInstructions.value !== newValue) {
                localSpecialInstructions.value = newValue;
            }
        });
        watch(() => props.quantity, (newValue) => {
            if (localQuantity.value !== newValue) {
                localQuantity.value = newValue;
            }
        });
        watch(() => props.selectedSize, (newValue) => {
            const next = newValue || null;
            if (localSelectedSize.value?.id !== next?.id) {
                localSelectedSize.value = next;
            }
        });
        // Auto-select default size when product changes
        watch(() => props.product, (newProduct) => {
            if (newProduct?.hasSizes &&
                newProduct.sizes &&
                newProduct.sizes.length > 0 &&
                !localSelectedSize.value) {
                const defaultSize = newProduct.sizes.find((size) => size.isDefault) || newProduct.sizes[0];
                localSelectedSize.value = defaultSize;
            }
            else if (!newProduct?.hasSizes) {
                localSelectedSize.value = null;
            }
        }, { immediate: true });
        // Computed
        const parseIngredientJsonString = (value) => {
            const trimmed = value.trim();
            if (!trimmed.startsWith("{") && !trimmed.startsWith("["))
                return null;
            try {
                const parsed = JSON.parse(trimmed);
                if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
                    return parsed;
                }
            }
            catch {
                return null;
            }
            return null;
        };
        const normalizeRemovableIngredientEntry = (entry) => {
            if (entry == null)
                return null;
            if (typeof entry === "string") {
                const parsed = parseIngredientJsonString(entry);
                if (parsed) {
                    return normalizeRemovableIngredientEntry(parsed);
                }
                const name = entry.trim();
                return name ? { id: name, name } : null;
            }
            const name = String(entry.name ?? "").trim();
            const id = String(entry.id || entry._id || name).trim();
            if (!name && !id)
                return null;
            if (!name && /^[a-f0-9]{24}$/i.test(id)) {
                return null;
            }
            return { id: id || name, name: name || id };
        };
        // Verfügbare entfernbare Zutaten (API: Objekte mit name/id oder Legacy-Strings)
        const availableRemovableIngredients = computed(() => {
            if (props.product?.removableIngredients &&
                props.product.removableIngredients.length > 0) {
                return props.product.removableIngredients
                    .map((entry) => normalizeRemovableIngredientEntry(entry))
                    .filter((entry) => entry != null);
            }
            if (props.product?.ingredients?.base && props.product.ingredients.base.length > 0) {
                return props.product.ingredients.base
                    .map((ingredient) => normalizeRemovableIngredientEntry(ingredient))
                    .filter((entry) => entry != null);
            }
            return [];
        });
        // Methods
        const hasValidAllergens = (allergens) => {
            return (allergens &&
                allergens.length > 0 &&
                allergens.some((allergen) => allergen.trim() !== ""));
        };
        // Allergen definitions - German names and descriptions
        const allergenDefinitions = {
            // Gluten variants
            gluten: {
                name: "Gluten",
                description: "enthält Glutenhaltiges Getreide (einschließlich Weizen)",
                icon: "gluten-icon.svg",
            },
            weizen: {
                name: "Gluten",
                description: "enthält Glutenhaltiges Getreide (einschließlich Weizen)",
                icon: "gluten-icon.svg",
            },
            getreide: {
                name: "Gluten",
                description: "enthält Glutenhaltiges Getreide (einschließlich Weizen)",
                icon: "gluten-icon.svg",
            },
            wheat: {
                name: "Gluten",
                description: "enthält Glutenhaltiges Getreide (einschließlich Weizen)",
                icon: "gluten-icon.svg",
            },
            a: {
                name: "Gluten",
                description: "enthält Glutenhaltiges Getreide (einschließlich Weizen)",
                icon: "gluten-icon.svg",
            },
            "1": {
                name: "Gluten",
                description: "enthält Glutenhaltiges Getreide (einschließlich Weizen)",
                icon: "gluten-icon.svg",
            },
            // Milk variants
            milch: {
                name: "Milch",
                description: "enthält Milch und Milcherzeugnisse (einschließlich Laktose)",
                icon: "milk-icon.svg",
            },
            laktose: {
                name: "Milch",
                description: "enthält Milch und Milcherzeugnisse (einschließlich Laktose)",
                icon: "milk-icon.svg",
            },
            lactose: {
                name: "Milch",
                description: "enthält Milch und Milcherzeugnisse (einschließlich Laktose)",
                icon: "milk-icon.svg",
            },
            milk: {
                name: "Milch",
                description: "enthält Milch und Milcherzeugnisse (einschließlich Laktose)",
                icon: "milk-icon.svg",
            },
            g: {
                name: "Milch",
                description: "enthält Milch und Milcherzeugnisse (einschließlich Laktose)",
                icon: "milk-icon.svg",
            },
            "7": {
                name: "Milch",
                description: "enthält Milch und Milcherzeugnisse (einschließlich Laktose)",
                icon: "milk-icon.svg",
            },
            // Egg variants
            ei: {
                name: "Eier",
                description: "enthält Eier und daraus gewonnene Erzeugnisse",
                icon: "egg-icon.svg",
            },
            eier: {
                name: "Eier",
                description: "enthält Eier und daraus gewonnene Erzeugnisse",
                icon: "egg-icon.svg",
            },
            egg: {
                name: "Eier",
                description: "enthält Eier und daraus gewonnene Erzeugnisse",
                icon: "egg-icon.svg",
            },
            eggs: {
                name: "Eier",
                description: "enthält Eier und daraus gewonnene Erzeugnisse",
                icon: "egg-icon.svg",
            },
            c: {
                name: "Eier",
                description: "enthält Eier und daraus gewonnene Erzeugnisse",
                icon: "egg-icon.svg",
            },
            "3": {
                name: "Eier",
                description: "enthält Eier und daraus gewonnene Erzeugnisse",
                icon: "egg-icon.svg",
            },
            // Fish variants
            fisch: {
                name: "Fisch",
                description: "enthält Fisch und Fischerzeugnisse",
                icon: "fish-icon.svg",
            },
            fish: {
                name: "Fisch",
                description: "enthält Fisch und Fischerzeugnisse",
                icon: "fish-icon.svg",
            },
            d: {
                name: "Fisch",
                description: "enthält Fisch und Fischerzeugnisse",
                icon: "fish-icon.svg",
            },
            "4": {
                name: "Fisch",
                description: "enthält Fisch und Fischerzeugnisse",
                icon: "fish-icon.svg",
            },
            // Peanut variants
            erdnuss: {
                name: "Erdnüsse",
                description: "enthält Erdnüsse und daraus gewonnene Erzeugnisse",
                icon: "peanut-icon.svg",
            },
            erdnüsse: {
                name: "Erdnüsse",
                description: "enthält Erdnüsse und daraus gewonnene Erzeugnisse",
                icon: "peanut-icon.svg",
            },
            peanut: {
                name: "Erdnüsse",
                description: "enthält Erdnüsse und daraus gewonnene Erzeugnisse",
                icon: "peanut-icon.svg",
            },
            peanuts: {
                name: "Erdnüsse",
                description: "enthält Erdnüsse und daraus gewonnene Erzeugnisse",
                icon: "peanut-icon.svg",
            },
            e: {
                name: "Erdnüsse",
                description: "enthält Erdnüsse und daraus gewonnene Erzeugnisse",
                icon: "peanut-icon.svg",
            },
            "5": {
                name: "Erdnüsse",
                description: "enthält Erdnüsse und daraus gewonnene Erzeugnisse",
                icon: "peanut-icon.svg",
            },
            // Soy variants
            soja: {
                name: "Soja",
                description: "enthält Sojabohnen und Sojaerzeugnisse",
                icon: "soy-icon.svg",
            },
            soy: {
                name: "Soja",
                description: "enthält Sojabohnen und Sojaerzeugnisse",
                icon: "soy-icon.svg",
            },
            soybean: {
                name: "Soja",
                description: "enthält Sojabohnen und Sojaerzeugnisse",
                icon: "soy-icon.svg",
            },
            f: {
                name: "Soja",
                description: "enthält Sojabohnen und Sojaerzeugnisse",
                icon: "soy-icon.svg",
            },
            "6": {
                name: "Soja",
                description: "enthält Sojabohnen und Sojaerzeugnisse",
                icon: "soy-icon.svg",
            },
            // Nuts variants
            nuss: {
                name: "Nüsse",
                description: "enthält Schalenfrüchte und daraus gewonnene Erzeugnisse",
                icon: "nuts-icon.svg",
            },
            nüsse: {
                name: "Nüsse",
                description: "enthält Schalenfrüchte und daraus gewonnene Erzeugnisse",
                icon: "nuts-icon.svg",
            },
            nuts: {
                name: "Nüsse",
                description: "enthält Schalenfrüchte und daraus gewonnene Erzeugnisse",
                icon: "nuts-icon.svg",
            },
            schalenfrüchte: {
                name: "Nüsse",
                description: "enthält Schalenfrüchte und daraus gewonnene Erzeugnisse",
                icon: "nuts-icon.svg",
            },
            h: {
                name: "Nüsse",
                description: "enthält Schalenfrüchte und daraus gewonnene Erzeugnisse",
                icon: "nuts-icon.svg",
            },
            "8": {
                name: "Nüsse",
                description: "enthält Schalenfrüchte und daraus gewonnene Erzeugnisse",
                icon: "nuts-icon.svg",
            },
            // Celery variants
            sellerie: {
                name: "Sellerie",
                description: "enthält Sellerie und daraus gewonnene Erzeugnisse",
                icon: "celery-icon.svg",
            },
            celery: {
                name: "Sellerie",
                description: "enthält Sellerie und daraus gewonnene Erzeugnisse",
                icon: "celery-icon.svg",
            },
            i: {
                name: "Sellerie",
                description: "enthält Sellerie und daraus gewonnene Erzeugnisse",
                icon: "celery-icon.svg",
            },
            "9": {
                name: "Sellerie",
                description: "enthält Sellerie und daraus gewonnene Erzeugnisse",
                icon: "celery-icon.svg",
            },
            // Mustard variants
            senf: {
                name: "Senf",
                description: "enthält Senf und Senferzeugnisse",
                icon: "mustard-icon.svg",
            },
            mustard: {
                name: "Senf",
                description: "enthält Senf und Senferzeugnisse",
                icon: "mustard-icon.svg",
            },
            j: {
                name: "Senf",
                description: "enthält Senf und Senferzeugnisse",
                icon: "mustard-icon.svg",
            },
            "10": {
                name: "Senf",
                description: "enthält Senf und Senferzeugnisse",
                icon: "mustard-icon.svg",
            },
            // Sesame variants
            sesam: {
                name: "Sesam",
                description: "enthält Sesamsamen und daraus gewonnene Erzeugnisse",
                icon: "sesame-icon.svg",
            },
            sesame: {
                name: "Sesam",
                description: "enthält Sesamsamen und daraus gewonnene Erzeugnisse",
                icon: "sesame-icon.svg",
            },
            k: {
                name: "Sesam",
                description: "enthält Sesamsamen und daraus gewonnene Erzeugnisse",
                icon: "sesame-icon.svg",
            },
            "11": {
                name: "Sesam",
                description: "enthält Sesamsamen und daraus gewonnene Erzeugnisse",
                icon: "sesame-icon.svg",
            },
            // Sulfites variants
            sulfite: {
                name: "Sulfite",
                description: "enthält Schwefeldioxid und Sulfite",
                icon: "sulfites-icon.svg",
            },
            sulfites: {
                name: "Sulfite",
                description: "enthält Schwefeldioxid und Sulfite",
                icon: "sulfites-icon.svg",
            },
            schwefeldioxid: {
                name: "Sulfite",
                description: "enthält Schwefeldioxid und Sulfite",
                icon: "sulfites-icon.svg",
            },
            sulfur: {
                name: "Sulfite",
                description: "enthält Schwefeldioxid und Sulfite",
                icon: "sulfites-icon.svg",
            },
            l: {
                name: "Sulfite",
                description: "enthält Schwefeldioxid und Sulfite",
                icon: "sulfites-icon.svg",
            },
            "12": {
                name: "Sulfite",
                description: "enthält Schwefeldioxid und Sulfite",
                icon: "sulfites-icon.svg",
            },
            // Shellfish variants
            schalen: {
                name: "Krebstiere",
                description: "enthält Krebstiere und daraus gewonnene Erzeugnisse",
                icon: "shellfish-icon.svg",
            },
            krebstiere: {
                name: "Krebstiere",
                description: "enthält Krebstiere und daraus gewonnene Erzeugnisse",
                icon: "shellfish-icon.svg",
            },
            krebs: {
                name: "Krebstiere",
                description: "enthält Krebstiere und daraus gewonnene Erzeugnisse",
                icon: "shellfish-icon.svg",
            },
            shellfish: {
                name: "Krebstiere",
                description: "enthält Krebstiere und daraus gewonnene Erzeugnisse",
                icon: "shellfish-icon.svg",
            },
            crustacean: {
                name: "Krebstiere",
                description: "enthält Krebstiere und daraus gewonnene Erzeugnisse",
                icon: "shellfish-icon.svg",
            },
            b: {
                name: "Krebstiere",
                description: "enthält Krebstiere und daraus gewonnene Erzeugnisse",
                icon: "shellfish-icon.svg",
            },
            "2": {
                name: "Krebstiere",
                description: "enthält Krebstiere und daraus gewonnene Erzeugnisse",
                icon: "shellfish-icon.svg",
            },
        };
        // Get allergen info from definitions
        const getAllergenInfo = (allergen) => {
            const allergenLower = allergen.toLowerCase().trim();
            // Direct match
            if (allergenDefinitions[allergenLower]) {
                return allergenDefinitions[allergenLower];
            }
            // Partial match (for compound allergen names)
            for (const [key, value] of Object.entries(allergenDefinitions)) {
                if (allergenLower.includes(key)) {
                    return value;
                }
            }
            // Fallback
            return {
                name: allergen,
                description: `enthält ${allergen}`,
                icon: "gluten-icon.svg",
            };
        };
        // Toggle allergen dropdown
        const toggleAllergenDropdown = () => {
            allergenDropdownOpen.value = !allergenDropdownOpen.value;
        };
        // Toggle special instructions dropdown
        const toggleSpecialInstructions = () => {
            specialInstructionsOpen.value = !specialInstructionsOpen.value;
            // ✅ Auto-focus textarea on mobile when opened - triggers keyboard
            if (specialInstructionsOpen.value) {
                nextTick(() => {
                    specialInstructionsTextarea.value?.focus();
                    // Scroll textarea into view on mobile
                    specialInstructionsTextarea.value?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                });
            }
        };
        // Mandatory Ingredients Methods
        const isMandatoryIngredientSelected = (groupId, ingredientId) => {
            return selectedMandatoryIngredients.value[groupId] === ingredientId;
        };
        const toggleMandatoryIngredient = (group, ingredient) => {
            // ✅ Use group NAME as stable key (not _id which may change on product updates)
            const groupId = group.name;
            const ingredientId = ingredient._id;
            // If max selection is 1 (radio behavior), always replace
            if (group.maxSelections === 1) {
                selectedMandatoryIngredients.value[groupId] = ingredientId;
            }
            else {
                // For multi-select (future), toggle
                if (selectedMandatoryIngredients.value[groupId] === ingredientId) {
                    delete selectedMandatoryIngredients.value[groupId];
                }
                else {
                    selectedMandatoryIngredients.value[groupId] = ingredientId;
                }
            }
            console.log('🎯 Mandatory ingredient selected:', {
                groupId,
                groupName: group.name,
                ingredientId,
                ingredientName: ingredient.name,
                allSelections: selectedMandatoryIngredients.value
            });
        };
        const isExtraSelected = (extraId) => {
            return (props.selectedExtras || []).some((selected) => selected.id === extraId);
        };
        const toggleExtraSelection = (extra) => {
            const current = props.selectedExtras || [];
            const isSelected = current.some((selected) => selected.id === extra.id);
            const next = isSelected
                ? current.filter((selected) => selected.id !== extra.id)
                : [...current, extra];
            emit("update:selectedExtras", next);
        };
        const isIngredientRemoved = (ingredientId) => {
            return removedIngredientIds.value.includes(ingredientId);
        };
        const toggleIngredientRemoval = (ingredient) => {
            const currentIds = removedIngredientIds.value;
            const isRemoved = currentIds.includes(ingredient.id);
            const nextIds = isRemoved
                ? currentIds.filter((id) => id !== ingredient.id)
                : [...currentIds, ingredient.id];
            const nextObjects = nextIds.map((id) => {
                const match = availableRemovableIngredients.value.find((entry) => entry.id === id);
                return match ? { id: match.id, name: match.name } : { id, name: id };
            });
            emit("update:removedIngredients", nextObjects);
        };
        // Get allergen summary for header
        const getAllergenSummary = (allergens) => {
            if (!allergens || allergens.length === 0)
                return "";
            const names = allergens.map((allergen) => getAllergenInfo(allergen).name);
            const uniqueNames = [...new Set(names)]; // Remove duplicates
            if (uniqueNames.length === 1)
                return uniqueNames[0];
            if (uniqueNames.length === 2)
                return `${uniqueNames[0]} und ${uniqueNames[1]}`;
            if (uniqueNames.length <= 3)
                return `${uniqueNames.slice(0, -1).join(", ")} und ${uniqueNames[uniqueNames.length - 1]}`;
            return `${uniqueNames.slice(0, 2).join(", ")} und ${uniqueNames.length - 2} weitere`;
        };
        // Get full description for expanded view
        const getAllergenFullDescription = (allergen) => {
            return getAllergenInfo(allergen).description;
        };
        // Icon mapping object for static imports
        const iconMap = {
            "gluten-icon.svg": glutenIcon,
            "milk-icon.svg": milkIcon,
            "egg-icon.svg": eggIcon,
            "fish-icon.svg": fishIcon,
            "peanut-icon.svg": peanutIcon,
            "soy-icon.svg": soyIcon,
            "nuts-icon.svg": nutsIcon,
            "celery-icon.svg": celeryIcon,
            "mustard-icon.svg": mustardIcon,
            "sesame-icon.svg": sesameIcon,
            "sulfites-icon.svg": sulfitesIcon,
            "shellfish-icon.svg": shellfishIcon,
        };
        // Get allergen icon path
        const getAllergenIcon = (allergen) => {
            const iconName = getAllergenInfo(allergen).icon;
            // Use static imports instead of require()
            if (iconMap[iconName]) {
                return iconMap[iconName];
            }
            console.warn("🚨 Could not find allergen icon:", iconName);
            // Fallback to gluten icon
            return glutenIcon;
        };
        // Handle icon loading errors
        const handleIconError = (event, allergen) => {
            const img = event.target;
            console.warn("🚨 Icon failed to load for allergen:", allergen);
            // Hide the image container or show a fallback
            img.style.display = "none";
        };
        const getProductPrice = () => {
            if (!props.product)
                return 0;
            let basePrice = 0;
            // ✅ FIX: Handle both price (euros) and priceCent (cents) fields
            if (props.product.price !== undefined && !isNaN(props.product.price)) {
                basePrice = props.product.price;
            }
            else if (props.product.priceCent !== undefined &&
                !isNaN(props.product.priceCent)) {
                // Fallback to priceCent conversion
                basePrice = props.product.priceCent / 100;
            }
            else {
                console.warn("Product has no valid price:", props.product);
                return 0;
            }
            // If product has sizes and one is selected, adjust price
            if (props.product.hasSizes && localSelectedSize.value) {
                return basePrice + getSizePrice(localSelectedSize.value);
            }
            return basePrice;
        };
        const getBaseProductPriceEuro = () => {
            if (!props.product)
                return 0;
            if (props.product.priceCent !== undefined &&
                props.product.priceCent !== null &&
                !Number.isNaN(Number(props.product.priceCent))) {
                return Number(props.product.priceCent) / 100;
            }
            if (props.product.price !== undefined && props.product.price !== null && !Number.isNaN(Number(props.product.price))) {
                return Number(props.product.price);
            }
            return 0;
        };
        // ✅ Robust size modifier calculation (supports legacy and mixed payloads)
        const getSizePrice = (size) => {
            if (!size)
                return 0;
            if (size.priceModifierCent !== undefined && size.priceModifierCent !== null && !Number.isNaN(Number(size.priceModifierCent))) {
                return Number(size.priceModifierCent) / 100;
            }
            // Legacy fallback: some payloads send absolute size price in cent
            if (size.priceCent !== undefined && size.priceCent !== null && !Number.isNaN(Number(size.priceCent))) {
                const baseEuro = getBaseProductPriceEuro();
                return Number(size.priceCent) / 100 - baseEuro;
            }
            // Legacy fallback: some payloads send absolute size price in euro
            if (size.price !== undefined && size.price !== null && !Number.isNaN(Number(size.price))) {
                const baseEuro = getBaseProductPriceEuro();
                return Number(size.price) - baseEuro;
            }
            return 0;
        };
        const formatPrice = (price) => {
            return new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR",
            }).format(price);
        };
        // Image error handling
        const handleImageError = (event) => {
            const img = event.target;
            img.src = defaultFoodImage;
            img.onerror = null; // Prevent infinite loop if default image also fails
        };
        // Validate mandatory ingredients - all groups must have a selection
        const validateMandatoryIngredients = () => {
            if (!props.product?.mandatoryIngredients || props.product.mandatoryIngredients.length === 0) {
                console.log('✅ [ConfigContent] No mandatory ingredients required for:', props.product?.name);
                return true; // No mandatory ingredients, always valid
            }
            console.log('🔍 [ConfigContent] Validating mandatory ingredients:', {
                productName: props.product?.name,
                groupCount: props.product.mandatoryIngredients.length,
                groups: props.product.mandatoryIngredients.map(g => g.name),
                currentSelections: selectedMandatoryIngredients.value
            });
            // Check if all groups have a selection
            // ✅ Use group.name consistently (same as toggle and computed)
            for (const group of props.product.mandatoryIngredients) {
                const groupId = group.name;
                if (!selectedMandatoryIngredients.value[groupId]) {
                    console.warn('⚠️ Mandatory ingredient group not filled:', group.name, {
                        groupId,
                        currentSelections: selectedMandatoryIngredients.value
                    });
                    return false;
                }
            }
            console.log('✅ [ConfigContent] validateMandatoryIngredients passed', {
                selections: selectedMandatoryIngredients.value
            });
            return true;
        };
        // ✅ Computed property for reactive validation - Vue automatically tracks selectedMandatoryIngredients changes
        const isMandatoryIngredientsValid = computed(() => {
            if (!props.product?.mandatoryIngredients || props.product.mandatoryIngredients.length === 0) {
                return true; // No mandatory ingredients, always valid
            }
            // Check if all groups have a selection
            // ✅ Use group NAME as stable key (consistent with toggleMandatoryIngredient)
            for (const group of props.product.mandatoryIngredients) {
                const groupId = group.name;
                if (!selectedMandatoryIngredients.value[groupId]) {
                    console.log('❌ [ConfigContent] Mandatory ingredient group not filled:', group.name, {
                        groupId,
                        currentSelections: selectedMandatoryIngredients.value
                    });
                    return false;
                }
            }
            console.log('✅ [ConfigContent] All mandatory ingredients filled', {
                selections: selectedMandatoryIngredients.value
            });
            return true;
        });
        // ✅ Track DOM elements of mandatory groups so we can scroll to them
        const groupRefs = new Map();
        const registerGroupRef = (groupName, el) => {
            if (el) {
                groupRefs.set(groupName, el);
            }
            else {
                groupRefs.delete(groupName);
            }
        };
        // ✅ Briefly highlighted group (set when user taps the disabled button)
        const highlightedGroup = ref(null);
        let highlightTimeout = null;
        // Scroll to the first unfilled mandatory group and highlight it briefly
        const highlightFirstInvalidGroup = () => {
            const groups = props.product?.mandatoryIngredients;
            if (!groups || groups.length === 0)
                return false;
            const firstInvalid = groups.find((group) => group.name &&
                group.ingredients &&
                group.ingredients.length > 0 &&
                !selectedMandatoryIngredients.value[group.name]);
            if (!firstInvalid)
                return false;
            const el = groupRefs.get(firstInvalid.name);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            highlightedGroup.value = firstInvalid.name;
            if (highlightTimeout)
                clearTimeout(highlightTimeout);
            highlightTimeout = setTimeout(() => {
                highlightedGroup.value = null;
                highlightTimeout = null;
            }, 1600);
            return true;
        };
        // Expose validation method AND computed property to parent
        __expose({
            validateMandatoryIngredients,
            isMandatoryIngredientsValid,
            selectedMandatoryIngredients, // ✅ Expose selections for pricing payload
            highlightFirstInvalidGroup // ✅ Scroll + highlight first unfilled mandatory group
        });
        return (_ctx, _cache) => {
            return (_ctx.product)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createCommentVNode(" Product Info "),
                    _createElementVNode("div", _hoisted_2, [
                        (_ctx.product.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.product.image,
                                alt: _ctx.product.name,
                                class: "w-32 h-32 object-cover rounded-lg flex-shrink-0",
                                onError: handleImageError
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", {
                                class: "text-xl font-bold",
                                style: _normalizeStyle({ color: _unref(theme).colors.primary })
                            }, [
                                (_ctx.product.hasSizes && _ctx.product.priceRange)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, " ab " + _toDisplayString(formatPrice(_ctx.product.priceRange.min)), 1 /* TEXT */))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(formatPrice(getProductPrice())), 1 /* TEXT */))
                            ], 4 /* STYLE */)
                        ])
                    ]),
                    _createCommentVNode(" Allergens Section - Outside product info container "),
                    (hasValidAllergens(_ctx.product.allergens))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", {
                                class: "rounded-lg p-4 border",
                                style: _normalizeStyle(allergenContainerStyle.value)
                            }, [
                                _createCommentVNode(" Header with dropdown toggle "),
                                _createElementVNode("div", {
                                    onClick: toggleAllergenDropdown,
                                    class: "flex items-center justify-between cursor-pointer hover:bg-gray-100 rounded-lg p-2 -m-2 transition-colors duration-200"
                                }, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("i", {
                                            class: "fas fa-exclamation-triangle text-lg mt-0.5 flex-shrink-0",
                                            style: _normalizeStyle({ color: warningColor.value })
                                        }, null, 4 /* STYLE */),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("h4", {
                                                class: "text-sm font-semibold",
                                                style: _normalizeStyle({ color: warningColor.value })
                                            }, "Allergene", 4 /* STYLE */),
                                            _createElementVNode("p", {
                                                class: "text-xs",
                                                style: _normalizeStyle({ color: warningColor.value })
                                            }, " enthält " + _toDisplayString(getAllergenSummary(_ctx.product.allergens || [])), 5 /* TEXT, STYLE */)
                                        ])
                                    ]),
                                    _createElementVNode("i", {
                                        class: _normalizeClass([allergenDropdownOpen.value ? 'fas fa-chevron-up' : 'fas fa-chevron-down', "text-sm transition-transform duration-200"]),
                                        style: _normalizeStyle({ color: warningColor.value })
                                    }, null, 6 /* CLASS, STYLE */)
                                ]),
                                _createCommentVNode(" Detailed allergen list (collapsible) "),
                                (allergenDropdownOpen.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "mt-4 space-y-2 border-t pt-4",
                                        style: _normalizeStyle(allergenDividerStyle.value)
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.allergens, (allergen) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: allergen,
                                                class: "flex items-center gap-3 p-2 bg-white rounded-lg border",
                                                style: _normalizeStyle(allergenItemStyle.value)
                                            }, [
                                                _createElementVNode("div", _hoisted_9, [
                                                    _createElementVNode("img", {
                                                        src: getAllergenIcon(allergen),
                                                        alt: allergen,
                                                        class: "w-8 h-8",
                                                        onError: ($event) => (handleIconError($event, allergen))
                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_10)
                                                ]),
                                                _createElementVNode("div", _hoisted_11, [
                                                    _createElementVNode("p", _hoisted_12, _toDisplayString(getAllergenFullDescription(allergen)), 1 /* TEXT */)
                                                ])
                                            ], 4 /* STYLE */));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ], 4 /* STYLE */))
                                    : _createCommentVNode("v-if", true)
                            ], 4 /* STYLE */)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Size Selection "),
                    (_ctx.product.hasSizes && _ctx.product.sizes && _ctx.product.sizes.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "text-base font-semibold text-gray-900" }, "Größe wählen", -1 /* CACHED */)),
                            _createElementVNode("div", null, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["grid gap-3", _ctx.product.sizes.length > 2 ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1'])
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.sizes, (size) => {
                                        return (_openBlock(), _createElementBlock("label", {
                                            key: size.id,
                                            class: _normalizeClass(["relative flex items-center justify-between p-4 bg-white rounded-lg border-2 cursor-pointer transition-all duration-200", {
                                                    'border-gray-200': localSelectedSize.value?.id !== size.id,
                                                }]),
                                            style: _normalizeStyle({
                                                borderColor: localSelectedSize.value?.id === size.id ? _unref(theme).colors.primary : undefined,
                                                backgroundColor: localSelectedSize.value?.id === size.id ? _unref(theme).colors.primary + '10' : undefined
                                            })
                                        }, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                value: size,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localSelectedSize).value = $event)),
                                                class: "sr-only"
                                            }, null, 8 /* PROPS */, _hoisted_14), [
                                                [_vModelRadio, localSelectedSize.value]
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _createCommentVNode(" Radio Circle "),
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(["w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200", {
                                                                'border-gray-400 bg-white': localSelectedSize.value?.id !== size.id,
                                                            }]),
                                                        style: _normalizeStyle({
                                                            borderColor: localSelectedSize.value?.id === size.id ? _unref(theme).colors.primary : undefined,
                                                            backgroundColor: localSelectedSize.value?.id === size.id ? _unref(theme).colors.primary : undefined
                                                        })
                                                    }, [
                                                        _withDirectives(_createElementVNode("div", _hoisted_17, null, 512 /* NEED_PATCH */), [
                                                            [_vShow, localSelectedSize.value?.id === size.id]
                                                        ])
                                                    ], 6 /* CLASS, STYLE */),
                                                    _createCommentVNode(" Size Info "),
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _createElementVNode("div", _hoisted_19, _toDisplayString(size.name), 1 /* TEXT */)
                                                    ])
                                                ])
                                            ]),
                                            _createCommentVNode(" Price "),
                                            _createElementVNode("div", _hoisted_20, [
                                                (getSizePrice(size) === 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, "inklusive"))
                                                    : (getSizePrice(size) > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, " +" + _toDisplayString(formatPrice(getSizePrice(size))), 1 /* TEXT */))
                                                        : (_openBlock(), _createElementBlock("div", {
                                                            key: 2,
                                                            class: "text-sm font-medium",
                                                            style: _normalizeStyle({ color: _unref(theme).colors.success })
                                                        }, _toDisplayString(formatPrice(getSizePrice(size))), 5 /* TEXT, STYLE */))
                                            ])
                                        ], 6 /* CLASS, STYLE */));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ], 2 /* CLASS */)
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Mandatory Ingredients "),
                    (_ctx.product.mandatoryIngredients && _ctx.product.mandatoryIngredients.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.mandatoryIngredients, (group) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: group.name,
                                    ref_for: true,
                                    ref: (el) => registerGroupRef(group.name, el),
                                    class: _normalizeClass(["mb-6 rounded-lg transition-all duration-300 scroll-mt-4", { 'mandatory-group-highlight': highlightedGroup.value === group.name }])
                                }, [
                                    _createCommentVNode(" Only show group if it has a valid name and ingredients "),
                                    (group.name && group.ingredients && group.ingredients.length > 0)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("h4", _hoisted_24, [
                                                _createTextVNode(_toDisplayString(group.name) + " ", 1 /* TEXT */),
                                                _createElementVNode("span", {
                                                    class: "text-sm font-normal",
                                                    style: _normalizeStyle({ color: requiredIndicatorColor.value })
                                                }, "*", 4 /* STYLE */)
                                            ]),
                                            _createElementVNode("div", _hoisted_25, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.ingredients, (ingredient) => {
                                                    return (_openBlock(), _createElementBlock("label", {
                                                        key: ingredient._id,
                                                        class: _normalizeClass(["relative flex items-center justify-between p-4 bg-white rounded-lg border-2 cursor-pointer transition-all duration-200", {
                                                                'border-gray-200': !isMandatoryIngredientSelected(group.name, ingredient._id),
                                                            }]),
                                                        style: _normalizeStyle({
                                                            borderColor: isMandatoryIngredientSelected(group.name, ingredient._id) ? _unref(theme).colors.primary : undefined,
                                                            backgroundColor: isMandatoryIngredientSelected(group.name, ingredient._id) ? _unref(theme).colors.primary + '10' : undefined
                                                        }),
                                                        onClick: ($event) => (toggleMandatoryIngredient(group, ingredient))
                                                    }, [
                                                        _createElementVNode("div", _hoisted_27, [
                                                            _createElementVNode("div", _hoisted_28, [
                                                                _createCommentVNode(" Radio/Checkbox Circle "),
                                                                _createElementVNode("div", {
                                                                    class: _normalizeClass(["w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200", {
                                                                            'border-gray-400 bg-white': !isMandatoryIngredientSelected(group.name, ingredient._id),
                                                                        }]),
                                                                    style: _normalizeStyle({
                                                                        borderColor: isMandatoryIngredientSelected(group.name, ingredient._id) ? _unref(theme).colors.primary : undefined,
                                                                        backgroundColor: isMandatoryIngredientSelected(group.name, ingredient._id) ? _unref(theme).colors.primary : undefined
                                                                    })
                                                                }, [
                                                                    _withDirectives(_createElementVNode("div", _hoisted_29, null, 512 /* NEED_PATCH */), [
                                                                        [_vShow, isMandatoryIngredientSelected(group.name, ingredient._id)]
                                                                    ])
                                                                ], 6 /* CLASS, STYLE */),
                                                                _createCommentVNode(" Ingredient Name "),
                                                                _createElementVNode("div", _hoisted_30, [
                                                                    _createElementVNode("div", _hoisted_31, _toDisplayString(ingredient.name), 1 /* TEXT */)
                                                                ])
                                                            ])
                                                        ]),
                                                        _createCommentVNode(" Optional: Price if applicable "),
                                                        (ingredient.price && ingredient.price > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                                _createElementVNode("div", _hoisted_33, " +" + _toDisplayString(formatPrice(ingredient.price)), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ], 14 /* CLASS, STYLE, PROPS */, _hoisted_26));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : _createCommentVNode("v-if", true)
                                ], 2 /* CLASS */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Extra Ingredients "),
                    (_ctx.product.extraIngredients && _ctx.product.extraIngredients.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "text-base font-semibold text-gray-900 mb-4" }, "Extras", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_35, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.extraIngredients, (extra) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                        key: extra.id,
                                        class: _normalizeClass(["relative flex items-center justify-between p-4 bg-white rounded-lg border-2 cursor-pointer transition-all duration-200", {
                                                'border-gray-200': !isExtraSelected(extra.id),
                                            }]),
                                        style: _normalizeStyle({
                                            borderColor: isExtraSelected(extra.id) ? _unref(theme).colors.success : undefined,
                                            backgroundColor: isExtraSelected(extra.id) ? _unref(theme).colors.success + '10' : undefined
                                        })
                                    }, [
                                        _createElementVNode("input", {
                                            type: "checkbox",
                                            checked: isExtraSelected(extra.id),
                                            onChange: ($event) => (toggleExtraSelection(extra)),
                                            class: "sr-only"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_36),
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("div", _hoisted_38, [
                                                _createCommentVNode(" Checkbox Square "),
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-200", {
                                                            'border-gray-400 bg-white': !isExtraSelected(extra.id),
                                                        }]),
                                                    style: _normalizeStyle({
                                                        borderColor: isExtraSelected(extra.id) ? _unref(theme).colors.success : undefined,
                                                        backgroundColor: isExtraSelected(extra.id) ? _unref(theme).colors.success : undefined
                                                    })
                                                }, [
                                                    _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_39, [...(_cache[3] || (_cache[3] = [
                                                            _createElementVNode("path", {
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round",
                                                                d: "M5 13l4 4L19 7"
                                                            }, null, -1 /* CACHED */)
                                                        ]))], 512 /* NEED_PATCH */)), [
                                                        [_vShow, isExtraSelected(extra.id)]
                                                    ])
                                                ], 6 /* CLASS, STYLE */),
                                                _createCommentVNode(" Extra Name "),
                                                _createElementVNode("div", _hoisted_40, [
                                                    _createElementVNode("div", _hoisted_41, _toDisplayString(extra.name), 1 /* TEXT */)
                                                ])
                                            ])
                                        ]),
                                        _createCommentVNode(" Price "),
                                        _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, " +" + _toDisplayString(formatPrice(extra.price)), 1 /* TEXT */)
                                        ])
                                    ], 6 /* CLASS, STYLE */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Removable Ingredients "),
                    (availableRemovableIngredients.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "text-base font-semibold text-gray-900 mb-4" }, "Zutaten entfernen", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_45, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRemovableIngredients.value, (ingredient) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                        key: ingredient.id,
                                        class: _normalizeClass(["relative flex items-center justify-between p-4 bg-white rounded-lg border-2 cursor-pointer transition-all duration-200", {
                                                'border-gray-200': !isIngredientRemoved(ingredient.id),
                                            }]),
                                        style: _normalizeStyle({
                                            borderColor: isIngredientRemoved(ingredient.id) ? _unref(theme).colors.danger : undefined,
                                            backgroundColor: isIngredientRemoved(ingredient.id) ? _unref(theme).colors.danger + '10' : undefined
                                        })
                                    }, [
                                        _createElementVNode("input", {
                                            type: "checkbox",
                                            checked: isIngredientRemoved(ingredient.id),
                                            onChange: ($event) => (toggleIngredientRemoval(ingredient)),
                                            class: "sr-only"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_46),
                                        _createElementVNode("div", _hoisted_47, [
                                            _createElementVNode("div", _hoisted_48, [
                                                _createCommentVNode(" Checkbox Square "),
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-200", {
                                                            'border-gray-400 bg-white': !isIngredientRemoved(ingredient.id),
                                                        }]),
                                                    style: _normalizeStyle({
                                                        borderColor: isIngredientRemoved(ingredient.id) ? _unref(theme).colors.danger : undefined,
                                                        backgroundColor: isIngredientRemoved(ingredient.id) ? _unref(theme).colors.danger : undefined
                                                    })
                                                }, [
                                                    _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_49, [...(_cache[5] || (_cache[5] = [
                                                            _createElementVNode("path", {
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round",
                                                                d: "M6 12h12"
                                                            }, null, -1 /* CACHED */)
                                                        ]))], 512 /* NEED_PATCH */)), [
                                                        [_vShow, isIngredientRemoved(ingredient.id)]
                                                    ])
                                                ], 6 /* CLASS, STYLE */),
                                                _createCommentVNode(" Ingredient Name "),
                                                _createElementVNode("div", _hoisted_50, [
                                                    _createElementVNode("div", _hoisted_51, _toDisplayString(ingredient.name), 1 /* TEXT */)
                                                ])
                                            ])
                                        ]),
                                        _createCommentVNode(" Remove Label "),
                                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-right" }, [
                                            _createElementVNode("div", { class: "text-sm text-gray-500" }, "entfernen")
                                        ], -1 /* CACHED */))
                                    ], 6 /* CLASS, STYLE */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Special Instructions "),
                    _createElementVNode("div", null, [
                        _createCommentVNode(" Header with dropdown toggle "),
                        _createElementVNode("div", {
                            onClick: toggleSpecialInstructions,
                            class: "flex items-center justify-between cursor-pointer hover:bg-gray-50 rounded-lg p-2 -m-2 transition-colors duration-200 mb-2"
                        }, [
                            _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "text-base font-semibold text-gray-900" }, "Besondere Wünsche", -1 /* CACHED */)),
                            _createElementVNode("i", {
                                class: _normalizeClass([specialInstructionsOpen.value ? 'fas fa-chevron-up' : 'fas fa-chevron-down', "text-gray-600 text-sm transition-transform duration-200"])
                            }, null, 2 /* CLASS */)
                        ]),
                        _createCommentVNode(" Textarea (collapsible) "),
                        (specialInstructionsOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                _withDirectives(_createElementVNode("textarea", {
                                    ref_key: "specialInstructionsTextarea",
                                    ref: specialInstructionsTextarea,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((localSpecialInstructions).value = $event)),
                                    placeholder: "z.B. extra scharf, ohne Sauce, gut durchgebraten...",
                                    class: "w-full p-3 text-gray-700 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:outline-none",
                                    style: _normalizeStyle({
                                        '--tw-ring-color': _unref(theme).colors.primary
                                    }),
                                    rows: "3",
                                    maxlength: "180"
                                }, null, 4 /* STYLE */), [
                                    [_vModelText, localSpecialInstructions.value]
                                ]),
                                _createElementVNode("div", _hoisted_53, _toDisplayString(localSpecialInstructions.value.length) + "/180 ", 1 /* TEXT */)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
